import modelOneApi from "../api/modelOne";

export default {
    computed: {
        api: function () {
            if (this.model)
                return modelOneApi.new(this.model);
        }
    },
    methods: {
        load() {
            this.$refs.table.load();
        },
        onEdit(item) {
            if (typeof this.formatBeforeEdit == "function") {
                this.formatBeforeEdit(item)
            }
            this.$refs.formDialog.open(item);
        },
        onCreate() {
            this.$refs.formDialog.open();
        },
        move(item, to) {
            modelOneApi.move(this.model, item.id, to, data => {
                if (data.ok) this.load();
            });
        },
        onDelete(item) {
            this.confirmDelete(item)
        },
        confirmDelete(item) {
            this.confirmDialog(
                "Are you sure want to delete the item?",
                () => {
                    this.delete(item);
                }
            );
        },
        delete(item) {
            modelOneApi.delete(this.model, item.id, data => {
                if (data.ok) this.load();
            });
        }
    }
}